export const AboutBlock = () => {
    return (
        <div className="about">
            <h2 className="about-title">Як це працює</h2>
            <div className="about-descr">Ви обираєте звук. І ви натискаєте на нього. Виберіть свій улюблений з безлічі звуків. Комбінуйте різні звуки разом!</div>
        </div>
    );
}